<template>
  <div class="view login">
    <div class="loading" :loading="loading"></div>
    <div class="login-note">
      <p>Mit Ihrem persönlichen Profil können Sie uns bequem Informationen und Dokumente zur Verfügung stellen oder sich auf offene Vakanzen bewerben.</p>
    </div>
    <div class="login-form">
      <h1>Kandidaten-Login</h1>
      <h5>Ihr Profil</h5>
      <div class="login-note mobile">
        <p>Mit Ihrem persönlichen Profil können Sie uns bequem Informationen und Dokumente zur Verfügung stellen oder sich auf offene Vakanzen bewerben.</p>
      </div>
      <form @submit.prevent="signIn">
        <div class="fieldgroup">
          <div class="field">
            <input type="email" placeholder="E-Mail" v-model="loginModel.email" required>
          </div>
        </div>
        <div class="fieldgroup">
          <div class="field">
            <input type="password" placeholder="Passwort" v-model="loginModel.password" required>
          </div>
        </div>
        <div class="error" v-if="error">{{error}}</div>
        <div class="buttons">
          <button type="submit" class="btn">Login</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'login',
  computed: {
    ...mapGetters({
      user: 'getUser',
      auth: 'getAuth'
    })
  },
  data() {
    return {
      error: null,
      loading: false,
      loginModel: {
        email: '',
        password: ''
      }
    }
  },
  watch: {
    user(u, previous) {
      if(!u || !previous) this.userChanged()
    }
  },
  methods: {
    signIn() {
      if(this.loading) return
      this.loading = true
      this.error = null
      this.auth().signInWithEmailAndPassword(this.loginModel.email, this.loginModel.password).catch(() => {
        this.error = 'Your email or password is incorrect.'
        this.loading = false
      })
    },
    userChanged() {
      this.loginModel = {
        email: '',
        password: ''
      }
      if(this.user) this.$router.push('/profile')
      this.loading = false
    }
  },
  mounted: function() {
    this.$store.commit('setTransition', false)
    window.addEventListener('login-failed', () => this.loading = false)
    this.userChanged()
  }
}
</script>

<style scoped>
.login:before {
  content: '';
  position: absolute;
  top: 0;
  left: 13.02vw;
  bottom: 0;
  width: 45.73vw;
  height: 54.26vh;
  margin: auto;
  background: url(../assets/tr_bg_login.jpg) no-repeat center/cover;
  opacity: .4;
}

.login-note {
  position: absolute;
  left: 11.46vw;
  bottom: 14.44vh;
  width: 18.52vw;
  padding: 2.96vh 2.19vw;
  letter-spacing: .05em;
  line-height: 1.875;
  color: #ffd675;
  z-index: 1;
}

.login-note.mobile {
  display: none;
}

.login-note:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 11.2vw;
  background: rgba(82, 82, 102, 0.23);
}

.login-note p {
  position: relative;
  margin: 0;
}

.login-form {
  position: absolute;
  top: 30.37vh;
  width: 31.77vw;
  right: 13.02vw;
  z-index: 1;
}

.login-form h1 {
  font: 400 3.98vh/1 'Exodus Demo St';
  color: #ffd675;
  margin: 0;
}

.login-form h5 {
  font-size: 1.3vh;
  letter-spacing: .4em;
  font-weight: 300;
  margin: 1.48vh 0 3.33vh;
}

.login-form input {
  background: none;
  border-radius: 0;
  border: 1px solid rgba(255, 255, 255, .5);
  height: 6.39vh;
  padding: 0 1.66vw;
  font-size: 1.85vh;
}

.login-form input::placeholder {
  font: 400 1.85vh/1 'Exodus Demo Stencil';
  color: #fff;
  opacity: 1;
}

.login-form .field {
  padding: 0;
  margin-bottom: 3.33vh;
}

.login-form .btn {
  font-size: 1.57vh;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: .3em;
  background: #ffd675;
  color: #0A1612;
  width: 13.02vw;
  height: 8.15vh;
}

.error {
  margin-top: -3.2vh;
}

@media screen and (max-width: 1024px) {
  .login:before {
    top: 206px;
    bottom: auto;
    left: 0;
    right: 0;
    width: auto;
    height: auto;
    padding-top: 66.66%;
  }
  .login-note {
    display: none;
  }
  .login-note.mobile {
    display: block;
    padding: 16px 36px;
  }
  .login-note:before {
    width: 100%;
    background: rgba(82, 82, 102, 0.46);
  }
  .login-note.mobile,
  .login-form {
    position: relative;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
    width: auto;
    text-align: center;
  }
  .login-form h1 {
    font-size: 34px;
    line-height: 1;
  }
  .login-form h5 {
    font-size: 11px;
    margin: 12px 0 118px;
  }
  .login-form form {
    padding: 0 36px;
    margin-top: 50px;
  }
  .login-form form input {
    border-color: rgba(82, 82, 102, 0.77);
    font-size: 11px;
    height: 40px;
    padding: 0 16px;
  }
  .login-form form input::placeholder {
    font-size: 11px;
  }
  .login-form .fieldgroup {
    margin: 0;
  }
  .login-form .field {
    margin-bottom: 20px;
  }
  .login-form .btn {
    width: 100%;
    font-size: 12px;
    height: 72px;
  }
}
</style>
